export function nickname(firstname: string, lastname: string) {
    let nickname = firstname
    if (lastname && nickname.length > 0) {
        nickname += '.' + lastname[0]
    }

    return nickname
}
